export const ITEMS_PAR_PAGE = 6;

export function discountedPrice(item) {
    const discountedPrice = item.price * (1 - item.discountedPercentage / 100);
    return Math.round(discountedPrice * 100) / 100; // Rounds to 2 decimal places
  }
  